import React, { useState } from 'react';
import { Form } from 'antd';
import { useTranslation } from 'react-i18next';
import { makePrioStyles } from '../../../theme/utils';
import { FolderPermission } from '../../../models/Settings';
import NewFolderForm, { CreateFolderRequest } from './NewFolderForm';
import { Modal } from '@prio365/prio365-react-library';

const useStyles = makePrioStyles((theme) => ({
  root: {},
  marginTop: {
    marginTop: theme.old.spacing.unit(1),
  },
}));

interface NewFolderModalProps {
  onOk: (value: CreateFolderRequest) => void;
  onCancel: () => void;
  visible: boolean;
  currentPath: string[];
  parentPermissions?: FolderPermission[];
  usePermissions?: boolean;
  confirmLoading?: boolean;
  groupId?: string;
  parentReferenceId?: string;
}

export const NewFolderModal: React.FC<NewFolderModalProps> = (props) => {
  //#region ------------------------------ Defaults
  const classes = useStyles();
  const {
    visible,
    onOk,
    onCancel,
    currentPath,
    parentPermissions,
    usePermissions,
    confirmLoading,
    groupId,
    parentReferenceId,
  } = props;
  const { t } = useTranslation();
  //#endregion

  //#region ------------------------------ States / Attributes / Selectors
  const [form] = Form.useForm<CreateFolderRequest>();
  const [nameIsValid, setNameIsValid] = useState<boolean>(true);
  const [isValidating, setIsValidating] = useState<boolean>(false);
  //#endregion

  //#region ------------------------------ Methods / Handlers
  const handleFinish = (value: CreateFolderRequest) => {
    onOk(value);
  };

  const handleOk = () => {
    form.validateFields().then(() => {
      form.submit();
    });
  };

  const handleCancel = () => {
    setNameIsValid(true);
    setIsValidating(false);
    form.resetFields();
    onCancel();
  };
  //#endregion

  //#region ------------------------------ Effects
  //#endregion

  return (
    <Modal
      className={classes.root}
      title={t('settings:projectFileSystemStructureEditor.newFolder.title')}
      okText={t('settings:projectFileSystemStructureEditor.newFolder.okText')}
      cancelText={t(
        'settings:projectFileSystemStructureEditor.newFolder.cancelText'
      )}
      onOk={handleOk}
      onClose={handleCancel}
      visible={visible}
      destroyOnClose
      cancelButtonProps={{ disabled: confirmLoading }}
      okButtonProps={{
        loading: confirmLoading || isValidating,

        disabled:
          isValidating || !nameIsValid || !form.getFieldsValue().folderName,
      }}
    >
      <NewFolderForm
        parentPermissions={parentPermissions}
        currentPath={currentPath}
        form={form}
        usePermissions={usePermissions}
        groupId={groupId}
        parentReferenceId={parentReferenceId}
        onFinish={handleFinish}
        setIsValid={setNameIsValid}
        setIsValidating={setIsValidating}
      />
    </Modal>
  );
};

export default NewFolderModal;
